"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f100 = void 0;
exports.f100 = {
    "dj": [
        5,
        410,
        2432,
        7019
    ],
    "djibouti": [
        73,
        5,
        410,
        2432,
        7019
    ],
    "dz": [
        21,
        411,
        449,
        474,
        1556,
        2433,
        2775,
        3458,
        3459,
        3460,
        3530,
        5256,
        5257,
        5258,
        5998,
        6860,
        6861,
        6862,
        7486,
        7487,
        7488,
        7489,
        7496,
        7527
    ],
    "dumut": [
        28,
        1238
    ],
    "divoire": [
        2244,
        3606,
        4447,
        5390,
        32,
        40,
        54,
        96,
        180,
        187,
        190,
        259,
        342,
        492,
        535,
        668,
        733,
        735,
        882,
        1071,
        1150,
        1741,
        1847,
        1919,
        2035,
        2041,
        2042,
        2055,
        2067,
        2293,
        2430,
        2625,
        2642,
        2712,
        2723,
        2726,
        2806,
        2841,
        2857,
        3101,
        3349,
        3411,
        3429,
        3621,
        3910,
        3991,
        4088,
        4099,
        4137,
        4164,
        4252,
        4457,
        4847,
        4960,
        5102,
        5228,
        5413,
        5446,
        5531,
        5757,
        6196,
        6384,
        6775,
        6779,
        6795,
        7412,
        7464,
        7526,
        8161,
        8203,
        8305,
        8462,
        8894
    ],
    "doma": [
        49,
        1903
    ],
    "dominican creole french": [
        65
    ],
    "dominican": [
        1944,
        65,
        2267
    ],
    "dok acoli": [
        66
    ],
    "dok": [
        66
    ],
    "djibouti arabic": [
        73
    ],
    "dangme": [
        87
    ],
    "dzodinka": [
        89
    ],
    "dzodzinka": [
        89
    ],
    "dhofari": [
        91
    ],
    "dhofari arabic": [
        91
    ],
    "dhopadhola": [
        93
    ],
    "dangbe": [
        100
    ],
    "derja": [
        117,
        116
    ],
    "darija": [
        449,
        116,
        117,
        456
    ],
    "de": [
        4581,
        5991,
        6418,
        6446,
        7649,
        8969,
        9126,
        2256,
        2275,
        1249,
        1795,
        6457,
        7164,
        119,
        305,
        450,
        463,
        464,
        472,
        493,
        568,
        602,
        603,
        605,
        608,
        666,
        887,
        936,
        1130,
        1146,
        1315,
        1330,
        1380,
        1440,
        1441,
        1461,
        1507,
        1516,
        1524,
        1528,
        1548,
        1568,
        1584,
        1614,
        1615,
        1631,
        1634,
        1635,
        1643,
        1648,
        1669,
        1676,
        1955,
        2058,
        2294,
        2346,
        2416,
        2466,
        2512,
        2555,
        2556,
        2652,
        2806,
        2918,
        3399,
        3518,
        3542,
        3827,
        3969,
        4032,
        4058,
        4500,
        4504,
        4571,
        4572,
        4590,
        4593,
        4594,
        4599,
        4624,
        4629,
        4637,
        4643,
        4673,
        4686,
        4697,
        4728,
        4792,
        4796,
        4797,
        4798,
        4799,
        4800,
        4803,
        4804,
        4807,
        4808,
        4812,
        4813,
        4815,
        4816,
        4817,
        4819,
        4901,
        4921,
        4994,
        4996,
        5016,
        5076,
        5121,
        5124,
        5157,
        5205,
        5206,
        5223,
        5224,
        5226,
        5229,
        5255,
        5264,
        5307,
        5341,
        5343,
        5345,
        5352,
        5356,
        5439,
        5449,
        5455,
        5458,
        5459,
        5464,
        5465,
        5466,
        5467,
        5556,
        5645,
        5704,
        5987,
        5988,
        5989,
        5995,
        5997,
        6045,
        6051,
        6056,
        6060,
        6064,
        6096,
        6193,
        6197,
        6251,
        6255,
        6264,
        6265,
        6277,
        6292,
        6354,
        6387,
        6393,
        6397,
        6399,
        6400,
        6401,
        6412,
        6417,
        6419,
        6422,
        6423,
        6426,
        6430,
        6434,
        6438,
        6440,
        6441,
        6444,
        6447,
        6533,
        6594,
        6754,
        6799,
        6896,
        6906,
        7120,
        7144,
        7303,
        7318,
        7360,
        7373,
        7413,
        7576,
        7640,
        7650,
        7653,
        7661,
        7669,
        7680,
        7691,
        7702,
        7716,
        7718,
        7752,
        7817,
        7925,
        7940,
        8106,
        8113,
        8116,
        8117,
        8118,
        8125,
        8127,
        8140,
        8141,
        8395,
        8579,
        8645,
        8646,
        8648,
        8652,
        8653,
        8654,
        8656,
        8658,
        8663,
        8664,
        8667,
        8970,
        8971,
        8972,
        8973,
        8974,
        8982,
        8983,
        8985,
        8986,
        8987,
        8988,
        8990,
        8992,
        9003,
        9113,
        9116,
        9117,
        9118,
        9119,
        9120,
        9121,
        9122,
        9123,
        9124,
        9125,
        9127,
        9128,
        9129,
        9130,
        9131,
        9132,
        9133,
        9134,
        9135,
        9136,
        9138,
        9139,
        9140,
        9141,
        9142,
        9143,
        9144,
        9145,
        9158,
        9160,
        9161,
        9162,
        9164,
        9165,
        9166,
        9167,
        9168,
        9169,
        9171,
        1782,
        1785,
        1787,
        1791,
        1792,
        1968,
        2142,
        2468,
        2473,
        2474,
        2692,
        2693,
        2731,
        2788,
        3058,
        3961,
        5375,
        5979,
        6110,
        6266,
        7174,
        7233,
        7264,
        8109,
        8210,
        8770,
        8798
    ],
    "defaka": [
        143
    ],
    "defaka-nkooro": [
        143
    ],
    "dinik": [
        147
    ],
    "ditti": [
        147
    ],
    "democratic": [
        674,
        899,
        3569,
        3668,
        3814,
        4001,
        4276,
        4942,
        5082,
        5423,
        5772,
        6995,
        6996,
        7026,
        8722,
        9103,
        3849,
        157,
        182,
        266,
        281,
        480,
        638,
        646,
        679,
        788,
        789,
        834,
        849,
        858,
        859,
        889,
        903,
        919,
        934,
        945,
        950,
        955,
        980,
        994,
        1007,
        1033,
        1070,
        1079,
        1083,
        1091,
        1101,
        1102,
        1103,
        1176,
        1190,
        1233,
        1241,
        1244,
        1254,
        1279,
        1309,
        1311,
        1549,
        1812,
        1867,
        1923,
        1942,
        2049,
        2065,
        2401,
        2412,
        2426,
        2496,
        2613,
        2656,
        2750,
        2906,
        2911,
        2927,
        2957,
        3005,
        3006,
        3007,
        3014,
        3031,
        3083,
        3240,
        3285,
        3347,
        3355,
        3410,
        3486,
        3527,
        3528,
        3537,
        3552,
        3620,
        3650,
        3667,
        3702,
        3703,
        3753,
        3845,
        3885,
        3975,
        3987,
        4005,
        4019,
        4090,
        4096,
        4147,
        4183,
        4204,
        4224,
        4229,
        4230,
        4231,
        4266,
        4269,
        4274,
        4284,
        4306,
        4312,
        4328,
        4334,
        4348,
        4401,
        4419,
        4438,
        4439,
        4445,
        4450,
        4454,
        4456,
        4492,
        4499,
        4517,
        4518,
        4524,
        4545,
        4548,
        4660,
        4661,
        4662,
        4664,
        4666,
        4667,
        4710,
        4879,
        4880,
        4925,
        5199,
        5204,
        5212,
        5234,
        5313,
        5331,
        5349,
        5350,
        5368,
        5369,
        5377,
        5380,
        5408,
        5421,
        5422,
        5438,
        5490,
        5491,
        5533,
        5549,
        5553,
        5592,
        5633,
        5717,
        5728,
        5746,
        5789,
        5793,
        5796,
        5814,
        5873,
        5908,
        5910,
        5938,
        6007,
        6018,
        6021,
        6100,
        6129,
        6130,
        6134,
        6178,
        6204,
        6247,
        6252,
        6275,
        6363,
        6568,
        6736,
        6832,
        6852,
        6932,
        6956,
        6959,
        6986,
        7027,
        7028,
        7038,
        7039,
        7065,
        7081,
        7147,
        7188,
        7225,
        7230,
        7231,
        7232,
        7287,
        7315,
        7341,
        7347,
        7389,
        7418,
        7459,
        7474,
        7503,
        7572,
        7609,
        7632,
        7652,
        7672,
        7762,
        7769,
        7894,
        8061,
        8316,
        8504,
        8763,
        8774,
        8843,
        8861,
        8867,
        8878,
        9074,
        9082,
        9086,
        9096,
        9097,
        9099,
        9106,
        9108
    ],
    "dumagat, remontado": [
        171
    ],
    "dumagat": [
        171,
        1815,
        400,
        1998,
        2005,
        2008,
        2017
    ],
    "djair": [
        179,
        8807
    ],
    "dyair": [
        179,
        8807
    ],
    "dialect": [
        200,
        616,
        1413,
        1414,
        1415,
        1416,
        1417,
        1418,
        1419,
        1420,
        1421,
        1608,
        1609,
        1612,
        1613,
        5081,
        6018,
        6019,
        6544,
        7452,
        9184
    ],
    "didán": [
        204,
        7706
    ],
    "doaniya": [
        210
    ],
    "djerbian arabic": [
        225,
        226
    ],
    "djerbian": [
        225,
        226
    ],
    "dyalna": [
        227,
        3421
    ],
    "dekwambre": [
        234
    ],
    "dho alur": [
        281
    ],
    "dho": [
        281,
        336,
        337,
        338
    ],
    "dhualur": [
        281
    ],
    "dhʉ alur": [
        281
    ],
    "dhʉ": [
        281
    ],
    "dha anyuaa": [
        336,
        337,
        338
    ],
    "dha": [
        336,
        337,
        338
    ],
    "dha anywak": [
        336,
        337,
        338
    ],
    "dho anywaa": [
        336,
        337,
        338
    ],
    "dho-anywaa": [
        336,
        337,
        338
    ],
    "dha anywaa": [
        337,
        338
    ],
    "denya": [
        339
    ],
    "dauri": [
        365
    ],
    "daleda": [
        384
    ],
    "dalekte": [
        384
    ],
    "dogon, ampari": [
        396
    ],
    "dogon": [
        396,
        1752,
        1763,
        1764,
        1766,
        1780,
        1814,
        1880,
        1897,
        1984,
        1985,
        1986,
        1988,
        1991,
        1992,
        1993,
        2036,
        5821,
        7388,
        1747
    ],
    "ditaylin alta": [
        400
    ],
    "ditaylin": [
        400
    ],
    "ditaylin dumagat": [
        400
    ],
    "darja": [
        449
    ],
    "dziria": [
        449
    ],
    "do": [
        2835,
        4679,
        450,
        472,
        479,
        567,
        933,
        934,
        935,
        1230,
        1955,
        2346,
        2836,
        3283,
        3284,
        3285,
        3286,
        3287,
        3474,
        3630,
        3840,
        4032,
        4628,
        4918,
        4921,
        5139,
        5197,
        5198,
        5199,
        5200,
        5201,
        5284,
        6022,
        7120,
        7251,
        7865,
        7866,
        7870,
        8240,
        8597,
        1944,
        2267
    ],
    "dian": [
        1908,
        2031,
        8949,
        8950,
        454,
        2973,
        2974,
        2975
    ],
    "dareja": [
        456
    ],
    "dereja": [
        456
    ],
    "des": [
        463,
        464,
        474,
        682,
        1006,
        1596,
        1597,
        1610,
        1611,
        1652,
        2350,
        2477,
        4490,
        6799,
        7146,
        8548
    ],
    "d’ivoire": [
        463,
        464
    ],
    "du": [
        2016,
        5128,
        463,
        464,
        1608,
        1609,
        1612,
        1613,
        1804,
        1805,
        2350,
        2655,
        3151,
        3518,
        5422,
        5581,
        6734,
        6735,
        6855,
        6856,
        7359,
        7629,
        7767,
        7863,
        8548
    ],
    "d’afrique": [
        463,
        464
    ],
    "dano": [
        473
    ],
    "davao": [
        489
    ],
    "djang": [
        525,
        6497,
        6498
    ],
    "dagestani": [
        532
    ],
    "dehati": [
        546,
        868,
        4577,
        4578,
        4579,
        4580
    ],
    "deshi": [
        546,
        4577,
        4578,
        4579,
        4580
    ],
    "dili": [
        7403,
        7532,
        7533,
        7534,
        592,
        593,
        596,
        597,
        2514,
        2515,
        2516,
        3104,
        3105,
        7535,
        7547,
        7548,
        7741
    ],
    "durango": [
        602,
        605
    ],
    "del": [
        3075,
        3091,
        3097,
        3100,
        6410,
        7691,
        602,
        603,
        604,
        605,
        623,
        1129,
        1444,
        1461,
        1548,
        1555,
        1644,
        1660,
        1665,
        1682,
        1697,
        3307,
        3315,
        3399,
        3875,
        4571,
        4581,
        4590,
        4594,
        4686,
        4798,
        4810,
        4812,
        5115,
        5157,
        5205,
        5220,
        5229,
        5343,
        5356,
        5454,
        5456,
        5458,
        5465,
        5466,
        5645,
        5718,
        5983,
        5987,
        5991,
        6051,
        6056,
        6060,
        6197,
        6216,
        6251,
        6265,
        6328,
        6330,
        6354,
        6383,
        6387,
        6407,
        6412,
        6417,
        6423,
        6424,
        6429,
        6440,
        6441,
        6889,
        7173,
        7303,
        7318,
        7373,
        7473,
        7551,
        7560,
        7576,
        7649,
        7661,
        7669,
        7680,
        7833,
        8117,
        8118,
        8126,
        8127,
        8141,
        8648,
        8656,
        8663,
        8971,
        8984,
        8986,
        9123,
        9134,
        9171
    ],
    "dum": [
        624
    ],
    "da": [
        1919,
        1920,
        2973,
        2974,
        2975,
        3024,
        8898,
        648,
        3047,
        3048,
        2204
    ],
    "dhibali": [
        674
    ],
    "dane-zaa": [
        714,
        715
    ],
    "dane-zaa záágé": [
        714,
        715
    ],
    "danezaa": [
        714,
        715
    ],
    "dunne-za": [
        714,
        715
    ],
    "dunneza": [
        714,
        715
    ],
    "darussalam": [
        721,
        1117,
        4102,
        4103,
        5069,
        7761,
        9019
    ],
    "dayak": [
        8449,
        1958,
        3830,
        5476,
        7602,
        723,
        3115,
        3844,
        4788,
        6993,
        7521,
        7838
    ],
    "daloa": [
        735
    ],
    "daloa bété": [
        735
    ],
    "daloua bété": [
        735
    ],
    "daloua": [
        735
    ],
    "desari": [
        781
    ],
    "diangan": [
        786
    ],
    "deshia": [
        800,
        1974
    ],
    "deswali": [
        822,
        823
    ],
    "dfola": [
        841
    ],
    "dongshan biao min": [
        862
    ],
    "dongshan": [
        862
    ],
    "didan": [
        863
    ],
    "dideni": [
        863
    ],
    "dah-hanu": [
        894
    ],
    "dokskat": [
        894
    ],
    "dia": [
        1845,
        917,
        1749
    ],
    "doi": [
        5028,
        7577,
        7936,
        928,
        929,
        930,
        931
    ],
    "dam": [
        933,
        934,
        935,
        1130,
        3466,
        5370,
        3008,
        4322,
        7023,
        7024
    ],
    "dai": [
        1853,
        9044,
        9045,
        1694,
        1729,
        1734,
        1735,
        1736,
        1737,
        1738,
        3645,
        3646,
        4326,
        7386,
        7387,
        933,
        934,
        935,
        1211,
        4824,
        7825,
        7826
    ],
    "den": [
        933,
        934,
        935,
        3879
    ],
    "dzamba": [
        980
    ],
    "dentong": [
        991
    ],
    "dor": [
        1018
    ],
    "daakaka": [
        1026
    ],
    "dakaka": [
        1026
    ],
    "dzao min": [
        1037
    ],
    "dzao": [
        1037
    ],
    "dzau min": [
        1037
    ],
    "dzau": [
        1037
    ],
    "deg": [
        3214,
        5278,
        1045
    ],
    "daihaati zabaan": [
        1077
    ],
    "daihaati": [
        1077
    ],
    "dehaati zabaan": [
        1077
    ],
    "dehaati": [
        1077
    ],
    "dutch": [
        5536,
        5537,
        5538,
        5539,
        5540,
        5541,
        5542,
        5543,
        1081,
        2006,
        5842,
        6935,
        1770,
        1969,
        6082,
        2208,
        8081
    ],
    "duga": [
        1091
    ],
    "dong": [
        1932,
        1935,
        3794,
        3795,
        1398,
        1399,
        1400,
        3852,
        1104,
        1361,
        1403,
        3799,
        4313,
        8923,
        8924,
        8925,
        8926
    ],
    "dusun": [
        2007,
        2010,
        2015,
        1989,
        4178,
        1117,
        1958,
        1990,
        7858,
        1889,
        2717,
        3322
    ],
    "dam de bousso": [
        1130
    ],
    "demsa bata": [
        1144
    ],
    "demsa": [
        1144
    ],
    "dii": [
        2011,
        1144
    ],
    "dunu": [
        1144
    ],
    "dairi": [
        1147
    ],
    "datagnon": [
        1155
    ],
    "dama": [
        1905,
        5821,
        1162,
        1970,
        5300
    ],
    "de’": [
        1177,
        1178
    ],
    "damraw": [
        1201
    ],
    "dibole": [
        1218
    ],
    "dareh": [
        1225,
        1226
    ],
    "dakenei": [
        1230
    ],
    "doko": [
        1233
    ],
    "de bor": [
        1249
    ],
    "di bor": [
        1249
    ],
    "di": [
        6083,
        1249,
        1867,
        4824
    ],
    "dyala": [
        1258
    ],
    "dyalanu": [
        1258
    ],
    "djenaama": [
        1300,
        1301
    ],
    "dos": [
        6422,
        1315,
        1955
    ],
    "dakelh": [
        1333,
        1623,
        1334,
        1624
    ],
    "daka": [
        1375,
        1860
    ],
    "dakka": [
        1888,
        1375,
        1860
    ],
    "dekka": [
        1375
    ],
    "deng": [
        1375,
        4785,
        5214,
        7870
    ],
    "daingnet": [
        1381,
        1382,
        1384
    ],
    "dikaka": [
        1425
    ],
    "dijim-bwilim": [
        1425
    ],
    "dzä": [
        1555,
        1584,
        1444,
        1629,
        1644,
        1682,
        1702
    ],
    "dene": [
        1452,
        1453,
        1804,
        1805,
        6734,
        6735,
        7465
    ],
    "dene suline": [
        1452,
        1453
    ],
    "dëne súline": [
        1452,
        1453
    ],
    "dëne": [
        1452,
        1453
    ],
    "dënesųłıné": [
        1452,
        1453
    ],
    "dsa": [
        1461
    ],
    "dagi": [
        1469
    ],
    "djok": [
        1484
    ],
    "daitu": [
        1519
    ],
    "delta river yuman": [
        1562
    ],
    "delta": [
        1562,
        6380
    ],
    "didiu": [
        1568
    ],
    "d’alene": [
        1601
    ],
    "dalene": [
        1601
    ],
    "dialeto": [
        1607,
        6286
    ],
    "doro": [
        1622,
        1946
    ],
    "dakelhne": [
        1623,
        1624
    ],
    "diola-kasa": [
        1640
    ],
    "duleigaiya": [
        1687
    ],
    "dubaku": [
        1693
    ],
    "dbaku": [
        1693,
        1697
    ],
    "duaku": [
        1693
    ],
    "dai ya": [
        1694
    ],
    "daiya": [
        1694
    ],
    "dibaku": [
        1697
    ],
    "duhumbi": [
        1700,
        1701
    ],
    "danish": [
        1719,
        1720,
        1721,
        1972,
        6543
    ],
    "dansk": [
        1719,
        1721,
        1720,
        1972
    ],
    "dänisch": [
        1719,
        1720
    ],
    "dk": [
        1719,
        1720,
        1972,
        2144,
        2409,
        3440,
        6543
    ],
    "denmark": [
        1719,
        1720,
        1972,
        2144,
        2409,
        3440,
        6543
    ],
    "dangaléat": [
        1722
    ],
    "daŋla": [
        1722
    ],
    "danal": [
        1722
    ],
    "dangal": [
        1722
    ],
    "dangla": [
        1722
    ],
    "dambi": [
        1723
    ],
    "dami": [
        1724
    ],
    "duupa": [
        1725
    ],
    "doupa": [
        1725
    ],
    "dupa": [
        1725
    ],
    "dagbani": [
        1726,
        1727
    ],
    "dagbanli": [
        1726,
        1727
    ],
    "dagbamba": [
        1726,
        1727
    ],
    "dagbane": [
        1726,
        1727
    ],
    "dagomba": [
        1726,
        1727
    ],
    "dahating": [
        1728
    ],
    "day": [
        1729,
        4326
    ],
    "daju, dar fur": [
        1730
    ],
    "daju": [
        1730,
        1742,
        1870
    ],
    "dar": [
        1730,
        1742,
        1870
    ],
    "dagu": [
        1730
    ],
    "daju ferne": [
        1730
    ],
    "dar fur daju": [
        1730
    ],
    "dakota": [
        1731,
        7172
    ],
    "dakhóta": [
        1731
    ],
    "dakhótiyapi": [
        1731
    ],
    "dahalo": [
        1732
    ],
    "damakawa": [
        1733
    ],
    "daai": [
        1734,
        1735,
        1736,
        1737,
        1738,
        9044,
        9045
    ],
    "daai chin": [
        1734,
        1735,
        1736,
        1737,
        1738
    ],
    "daar": [
        1738
    ],
    "dandami": [
        1739
    ],
    "dandami madiya": [
        1739
    ],
    "dandami maria": [
        1739
    ],
    "dhuru": [
        1739
    ],
    "dargwa": [
        1740
    ],
    "dargan medz": [
        1740
    ],
    "dargan": [
        1740
    ],
    "dargi": [
        1740,
        6827
    ],
    "dargin": [
        1740
    ],
    "darginski": [
        1740
    ],
    "dargintsy": [
        1740
    ],
    "dargva": [
        1740
    ],
    "daho-doo": [
        1741
    ],
    "daju, dar sila": [
        1742
    ],
    "dadjo": [
        1742,
        1870
    ],
    "dajou": [
        1742,
        1870
    ],
    "dar sila": [
        1742
    ],
    "dar sila daju": [
        1742
    ],
    "dawida": [
        1743
    ],
    "dabida": [
        1743,
        7812
    ],
    "davida": [
        1743
    ],
    "davawenyo": [
        1744,
        4142,
        5065
    ],
    "davaoeño": [
        1744
    ],
    "davaweño": [
        1744,
        4142
    ],
    "dayi": [
        1745
    ],
    "dhay’yi": [
        1745
    ],
    "dha’i": [
        1745
    ],
    "dao": [
        1746,
        3283,
        3284,
        3285,
        3286,
        3287,
        4824,
        5415,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "dyeni": [
        1747
    ],
    "deno": [
        1748,
        3855
    ],
    "denawa": [
        1748,
        3855
    ],
    "denwa": [
        1748,
        3855
    ],
    "dadiya": [
        1749
    ],
    "daddi̱ya": [
        1749
    ],
    "daadiya": [
        1749
    ],
    "dadia": [
        1749
    ],
    "dabe": [
        1750
    ],
    "dosobou": [
        1751
    ],
    "dou": [
        1751
    ],
    "doufou": [
        1751
    ],
    "dogon, dogul dom": [
        1752
    ],
    "dogul": [
        1752
    ],
    "dom": [
        1930,
        1752,
        1764,
        2036,
        1903,
        1934,
        6560,
        7066,
        7388
    ],
    "dogul dom dogon": [
        1752
    ],
    "dogul-dom": [
        1752
    ],
    "doka": [
        1753,
        8853
    ],
    "dyirbal": [
        1756
    ],
    "djirubal": [
        1756
    ],
    "duguri": [
        1757
    ],
    "dugarwa": [
        1757
    ],
    "duguranci": [
        1757
    ],
    "dugurawa": [
        1757
    ],
    "dukuri": [
        1757
    ],
    "dõõri": [
        1757
    ],
    "duriankere": [
        1758
    ],
    "duriankari": [
        1758
    ],
    "dulbu": [
        1759
    ],
    "duwai": [
        1760
    ],
    "daba": [
        1761,
        1821,
        6978
    ],
    "dabba": [
        1761
    ],
    "dabarre": [
        1762
    ],
    "dogon, ben tey": [
        1763
    ],
    "dogon, bondum dom": [
        1764
    ],
    "dungu": [
        1765
    ],
    "dingi": [
        1765
    ],
    "dungi": [
        1765
    ],
    "dunjawa": [
        1765
    ],
    "dwingi": [
        1765
    ],
    "dogon, bankan tey": [
        1766
    ],
    "dibiyaso": [
        1767
    ],
    "dibiasu": [
        1767
    ],
    "deccan": [
        1768,
        1769
    ],
    "dakhini": [
        1768,
        1769,
        2933,
        2934,
        2935,
        2936
    ],
    "dakhni": [
        1768,
        1769
    ],
    "dakini": [
        1768,
        1769
    ],
    "dakkani": [
        1768,
        1769
    ],
    "dakkhani": [
        1768,
        1769
    ],
    "deccani": [
        1768,
        1769
    ],
    "desi": [
        1768,
        1769
    ],
    "dutch creole": [
        1770
    ],
    "dadi dadi": [
        1771
    ],
    "dadi": [
        1771
    ],
    "dadidadi": [
        1771
    ],
    "dardi-dardi": [
        1771
    ],
    "dardidardi": [
        1771
    ],
    "dongotono": [
        1772
    ],
    "doondo": [
        1773
    ],
    "dondo": [
        1939,
        1773
    ],
    "dagada": [
        1774
    ],
    "dagaga": [
        1774
    ],
    "dagoda’": [
        1774
    ],
    "diodio": [
        1775
    ],
    "djaru": [
        1776
    ],
    "dendi": [
        1777,
        1807
    ],
    "dandawa": [
        1777
    ],
    "dandi": [
        1777
    ],
    "dendi (benin)": [
        1777
    ],
    "dido": [
        1778
    ],
    "didoi": [
        1778
    ],
    "dhudhuroa": [
        1779
    ],
    "dogon, donno so": [
        1780
    ],
    "donno": [
        1780
    ],
    "donno so": [
        1780
    ],
    "donno so dogon": [
        1780
    ],
    "dawera-daweloor": [
        1781
    ],
    "davelor": [
        1781
    ],
    "deutsch": [
        1782,
        1784,
        1788,
        1789,
        1790,
        1783,
        1785,
        1787,
        1791,
        1792
    ],
    "duits": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "däitsch": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "dagik": [
        1793
    ],
    "dagig": [
        1793
    ],
    "dhaduwa": [
        1793
    ],
    "dharuwa": [
        1793
    ],
    "duwa": [
        1793
    ],
    "dedua": [
        1794
    ],
    "dewoin": [
        1795
    ],
    "dei": [
        1795,
        3249,
        6944
    ],
    "dewoi": [
        1795
    ],
    "dey": [
        8765,
        1795
    ],
    "dezfuli": [
        1796
    ],
    "dezfuli-shushtari": [
        1796
    ],
    "dezhfili": [
        1796
    ],
    "dizfuli": [
        1796
    ],
    "degema": [
        1797
    ],
    "dehwari": [
        1798
    ],
    "deghwari": [
        1798
    ],
    "demisa": [
        1799
    ],
    "desawa": [
        1799
    ],
    "dek": [
        1800
    ],
    "delaware": [
        1801,
        1806,
        1802,
        7974
    ],
    "dem": [
        1803,
        4079
    ],
    "deh gáh ghotie zhatie": [
        1804,
        1805
    ],
    "deh": [
        1804,
        1805
    ],
    "dene tha’": [
        1804,
        1805
    ],
    "denetha": [
        1804,
        1805
    ],
    "dené": [
        1804,
        1805,
        6734,
        6735
    ],
    "delaware, pidgin": [
        1806
    ],
    "dendi (central african republic)": [
        1807
    ],
    "deori": [
        1808,
        1809
    ],
    "dari": [
        2564,
        6299,
        1808,
        1809
    ],
    "deori-chutiya": [
        1808,
        1809
    ],
    "deuri": [
        1808,
        1809
    ],
    "dewri": [
        1808,
        1809
    ],
    "drori": [
        1808,
        1809
    ],
    "desano": [
        1810
    ],
    "desana-siriana": [
        1810,
        7109
    ],
    "dessana": [
        1810
    ],
    "dessano": [
        1810
    ],
    "desána": [
        1810
    ],
    "desâna": [
        1810
    ],
    "domung": [
        1811
    ],
    "dengese": [
        1812
    ],
    "dagaare, southern": [
        1813
    ],
    "dagaare": [
        1813,
        1820
    ],
    "dagara": [
        1820,
        1813
    ],
    "dagare": [
        1813
    ],
    "dagari": [
        1813,
        1816,
        1820
    ],
    "dagati": [
        1813,
        1820
    ],
    "degati": [
        1813,
        1820
    ],
    "dogaari": [
        1813,
        1820
    ],
    "dogon, bunoge": [
        1814
    ],
    "dagaari dioula": [
        1816
    ],
    "dagaari": [
        1816,
        1820
    ],
    "dioula": [
        1816,
        2040,
        2041,
        2042
    ],
    "dagaari jula": [
        1816
    ],
    "dagari dyoula": [
        1816
    ],
    "dyoula": [
        2040,
        2041,
        2042,
        1816
    ],
    "degenang": [
        1817
    ],
    "degenan": [
        1817
    ],
    "dingana": [
        1817
    ],
    "doga": [
        1818
    ],
    "dghwede": [
        1819
    ],
    "dghwéɗè": [
        1819
    ],
    "dehoxde": [
        1819
    ],
    "dagara, northern": [
        1820
    ],
    "dagaara": [
        1820
    ],
    "dagba": [
        1821
    ],
    "danaagla": [
        1822,
        1823,
        1824
    ],
    "danaqla": [
        1822,
        1823,
        1824
    ],
    "dongola": [
        1822,
        1823,
        1824
    ],
    "dongola nubian": [
        1822,
        1823,
        1824
    ],
    "dongolawi": [
        1822,
        1823,
        1824
    ],
    "dongolawi nubian": [
        1822,
        1823,
        1824
    ],
    "dongolese": [
        1822,
        1823,
        1824
    ],
    "dagoman": [
        1825,
        3402
    ],
    "dogrib": [
        1826
    ],
    "dogoso": [
        1827,
        1991
    ],
    "dogose": [
        1827
    ],
    "dorhosié-finng": [
        1827
    ],
    "dorhosié-noirs": [
        1827
    ],
    "dorossié-fing": [
        1827
    ],
    "degaru": [
        1829
    ],
    "daungwurrung": [
        1830
    ],
    "daung wurrung": [
        1830
    ],
    "daung": [
        1830
    ],
    "dhagung-wurrung": [
        1830
    ],
    "doghoro": [
        1831
    ],
    "dogoro": [
        1831
    ],
    "daga": [
        1832,
        8580
    ],
    "dimuga": [
        1832
    ],
    "dhangu-djangu": [
        1833
    ],
    "dangu": [
        1833
    ],
    "dhaangu": [
        1833
    ],
    "dhangu": [
        1833
    ],
    "dhangu’mi": [
        1833
    ],
    "djangu": [
        1833
    ],
    "dhimal": [
        1834
    ],
    "dhemal": [
        1834
    ],
    "dhalandji": [
        1835
    ],
    "dalandji": [
        1835
    ],
    "dalendi": [
        1835
    ],
    "djalendi": [
        1835
    ],
    "dhimba": [
        1836
    ],
    "dimba": [
        1836
    ],
    "dangi": [
        1837
    ],
    "dangri": [
        1837
    ],
    "dangs bhil": [
        1837
    ],
    "dangs": [
        1837
    ],
    "dhanka": [
        1837
    ],
    "dhanki": [
        1837
    ],
    "dhodia": [
        1838
    ],
    "dhobi": [
        1838
    ],
    "dhore": [
        1838
    ],
    "dhori": [
        1838
    ],
    "dhowari": [
        1838
    ],
    "doria": [
        1838
    ],
    "dhargari": [
        1839
    ],
    "dal’gari": [
        1839
    ],
    "dargari": [
        1839
    ],
    "dhaiso": [
        1840
    ],
    "daiso": [
        1840
    ],
    "daisu": [
        1840
    ],
    "dhurga": [
        1841
    ],
    "dhuurga": [
        1841
    ],
    "dhu’rga": [
        1841
    ],
    "durga": [
        1841
    ],
    "duurga": [
        1841
    ],
    "drehu": [
        1842
    ],
    "dehu": [
        1842
    ],
    "de’u": [
        1842
    ],
    "danuwar": [
        1843,
        2030
    ],
    "danuwari": [
        1843
    ],
    "danwar": [
        1843
    ],
    "denwar": [
        1843
    ],
    "dhanuwar": [
        1843
    ],
    "dhanvar": [
        1843
    ],
    "dhanwar": [
        1843
    ],
    "dhanwar (nepal)": [
        1843
    ],
    "donwar": [
        1843
    ],
    "dhungaloo": [
        1844
    ],
    "dungaloo": [
        1844
    ],
    "dinka, south central": [
        1846
    ],
    "dinka": [
        1846,
        1856,
        1857,
        1859,
        1864,
        1890
    ],
    "dida, lakota": [
        1847
    ],
    "dida": [
        1847,
        2806
    ],
    "dieko": [
        1847
    ],
    "didinga": [
        1848
    ],
    "dĩdĩnga": [
        1848
    ],
    "diyari": [
        1849
    ],
    "dhirari": [
        1849
    ],
    "dieri": [
        1849
    ],
    "dirari": [
        1849
    ],
    "digo": [
        1850
    ],
    "diegueño": [
        1851
    ],
    "digueño": [
        1851
    ],
    "dimbong": [
        1852
    ],
    "dilling": [
        1854
    ],
    "delen": [
        1854
    ],
    "dime": [
        1855,
        2715
    ],
    "dinka: southwestern": [
        1856
    ],
    "dinka, southwestern": [
        1856,
        1857
    ],
    "dibo": [
        1858
    ],
    "dinka, northeastern": [
        1859
    ],
    "dirim": [
        1860
    ],
    "dirin": [
        1860
    ],
    "dirrim": [
        1860
    ],
    "dimasa": [
        1861,
        1862
    ],
    "dimasa kachari": [
        1861,
        1862
    ],
    "dima": [
        3389,
        1861,
        1862
    ],
    "dciriku": [
        1863
    ],
    "dirico": [
        1863
    ],
    "diriko": [
        1863
    ],
    "diriku": [
        1863
    ],
    "dinka, northwestern": [
        1864
    ],
    "dixon reef": [
        1865
    ],
    "dixon": [
        1865
    ],
    "diuwe": [
        1866
    ],
    "ding": [
        1867
    ],
    "din": [
        1867
    ],
    "dinga": [
        1867
    ],
    "dzing": [
        1867
    ],
    "djadjawurrung": [
        1868
    ],
    "djadja wurrung": [
        1868
    ],
    "djadja": [
        1868
    ],
    "djadjawurung": [
        1868
    ],
    "dyadyawurung": [
        1868
    ],
    "djinba": [
        1869
    ],
    "daju, dar daju": [
        1870
    ],
    "dadju": [
        1870
    ],
    "dajo": [
        1870
    ],
    "daju mongo": [
        1870
    ],
    "daju oum hadjer": [
        1870
    ],
    "dar daju daju": [
        1870
    ],
    "djamindjung": [
        1871
    ],
    "djerma": [
        1872,
        1873,
        1874
    ],
    "dyabarma": [
        1872,
        1873,
        1874
    ],
    "dyarma": [
        1872,
        1873,
        1874
    ],
    "dyerma": [
        1872,
        1873,
        1874
    ],
    "djangun": [
        1875
    ],
    "djanggun": [
        1875
    ],
    "djinang": [
        1876
    ],
    "djeebbana": [
        1877
    ],
    "dogon, jamsay": [
        1880
    ],
    "dyamsay tegu": [
        1880
    ],
    "dyamsay": [
        1880
    ],
    "djauan": [
        1881
    ],
    "djawan": [
        1881
    ],
    "djongkang": [
        1882
    ],
    "djambarrpuyngu": [
        1883
    ],
    "djambarbwingu": [
        1883
    ],
    "djawi": [
        1885
    ],
    "djaui": [
        1885
    ],
    "dakpakha": [
        1886
    ],
    "dakpa": [
        1886,
        6823,
        7828
    ],
    "dinka, southeastern": [
        1890
    ],
    "dolgan": [
        1892
    ],
    "dolgang": [
        1892
    ],
    "dahalik": [
        1893
    ],
    "dahlak": [
        1893
    ],
    "dalmatian": [
        1894
    ],
    "darlong": [
        1895
    ],
    "dalong": [
        1895
    ],
    "duma": [
        1896
    ],
    "douma": [
        1896
    ],
    "dogon, mombo": [
        1897
    ],
    "dimir": [
        1898
    ],
    "dugwor": [
        1900
    ],
    "dougour": [
        1900
    ],
    "domaaki": [
        1903
    ],
    "dawoodi": [
        1903
    ],
    "dumaki": [
        1903
    ],
    "dameli": [
        1904
    ],
    "damedi": [
        1904
    ],
    "damel": [
        1904
    ],
    "damia": [
        1904
    ],
    "damiabaasha": [
        1904
    ],
    "dama-mono": [
        1905
    ],
    "diábékwálé": [
        1906
    ],
    "dumbo": [
        1906
    ],
    "dzumbo": [
        1906
    ],
    "damar, east": [
        1907
    ],
    "damar": [
        1907,
        1961
    ],
    "dampelas": [
        1908
    ],
    "dampelasa": [
        1908
    ],
    "dubu": [
        1909
    ],
    "dumpas": [
        1910
    ],
    "doompas": [
        1910
    ],
    "dema": [
        1912,
        7791
    ],
    "demta": [
        1913
    ],
    "dani, upper grand valley": [
        1914
    ],
    "dani": [
        1914,
        1918,
        1925,
        1928,
        1929
    ],
    "daonda": [
        1915
    ],
    "dungan": [
        1917
    ],
    "dzhunyan": [
        1917
    ],
    "dani, lower grand valley": [
        1918
    ],
    "dan": [
        1919,
        1920,
        2031
    ],
    "dã̀ã̀": [
        1919,
        1920
    ],
    "dàn": [
        1919,
        1920
    ],
    "dan (blowo)": [
        1920
    ],
    "dengka": [
        1921
    ],
    "dzùùngoo": [
        1922
    ],
    "dzùùn": [
        1922
    ],
    "duun": [
        1922,
        2016
    ],
    "ddradha": [
        1923
    ],
    "ddraló": [
        1923
    ],
    "danaru": [
        1924
    ],
    "dani, mid grand valley": [
        1925
    ],
    "danau": [
        1926
    ],
    "danaw": [
        1926
    ],
    "danu": [
        1927
    ],
    "dani, western": [
        1928
    ],
    "dani barat": [
        1928
    ],
    "dení": [
        1929
    ],
    "dobu": [
        1931
    ],
    "dobuan": [
        1931
    ],
    "dong, northern": [
        1932
    ],
    "doe": [
        1933
    ],
    "dohe": [
        1933
    ],
    "dowe": [
        1933
    ],
    "domu": [
        1934
    ],
    "donga": [
        1935,
        1942
    ],
    "dogri (macrolanguage)": [
        1936,
        1937,
        1938
    ],
    "dogri": [
        1936,
        1937,
        1938
    ],
    "dhogaryali": [
        1936,
        1937,
        1938
    ],
    "dogari": [
        1936,
        1937,
        1938
    ],
    "dogri jammu": [
        1936,
        1937,
        1938
    ],
    "dogri pahari": [
        1936,
        1937,
        1938
    ],
    "dogri-kangri": [
        1936,
        1937,
        1938
    ],
    "dongari": [
        1936,
        1937,
        1938
    ],
    "doso": [
        1940,
        4860
    ],
    "doura": [
        1941
    ],
    "dongo": [
        1942
    ],
    "dhɔ̀ngɔ̀kɔ́": [
        1942
    ],
    "dongo ko": [
        1942
    ],
    "dompago": [
        1943
    ],
    "dominican sign language": [
        1944
    ],
    "dominican republic": [
        1944,
        2267
    ],
    "dori’o": [
        1945
    ],
    "dori'o": [
        1945
    ],
    "dogosé": [
        1946
    ],
    "doghose": [
        1946
    ],
    "doghosié": [
        1946
    ],
    "dokhobe": [
        1946
    ],
    "dokhosié": [
        1946
    ],
    "dorhossié": [
        1946
    ],
    "dorhosye": [
        1946
    ],
    "doro doghosié": [
        1946
    ],
    "dorobé": [
        1946
    ],
    "dorosie": [
        1946
    ],
    "dorossé": [
        1946
    ],
    "dass": [
        1947
    ],
    "dombe": [
        1948,
        5373
    ],
    "doyayo": [
        1949
    ],
    "dooya̰a̰yɔ": [
        1949
    ],
    "doayo": [
        1949
    ],
    "donyanyo": [
        1949
    ],
    "donyayo": [
        1949
    ],
    "doohyaayo": [
        1949
    ],
    "doowaaya̰a̰yɔ": [
        1949
    ],
    "doowaayo": [
        1949
    ],
    "dooyaangyo": [
        1949
    ],
    "dooyaayo": [
        1949
    ],
    "dooyayo": [
        1949
    ],
    "dowayayo": [
        1949
    ],
    "dowayo": [
        1949
    ],
    "doyaayo": [
        1949
    ],
    "doyau": [
        1949
    ],
    "dompo": [
        1951
    ],
    "dumpo": [
        1951
    ],
    "dorze": [
        1952
    ],
    "dair": [
        1954
    ],
    "dabab": [
        1954
    ],
    "daier": [
        1954
    ],
    "darmiya": [
        1956
    ],
    "darimiya": [
        1956
    ],
    "darma": [
        1956
    ],
    "darma lwo": [
        1956
    ],
    "darma-lwo": [
        1956
    ],
    "darmani": [
        1956
    ],
    "dolpo": [
        1957
    ],
    "dhol-wa": [
        1957
    ],
    "dolkha": [
        1957
    ],
    "dolpa tibetan": [
        1957
    ],
    "dolpa": [
        1957
    ],
    "dolpali": [
        1957
    ],
    "dolpike": [
        1957
    ],
    "dayak laut": [
        1958
    ],
    "dusun dayak": [
        1958
    ],
    "dakakari": [
        1959
    ],
    "dakarci": [
        1959
    ],
    "dakarkari": [
        1959
    ],
    "dakkarkari": [
        1959
    ],
    "darling": [
        1960
    ],
    "damar, west": [
        1961
    ],
    "daro-matu": [
        1962
    ],
    "daro-matu melanau": [
        1962
    ],
    "dura": [
        1963
    ],
    "drents": [
        1965
    ],
    "dreins": [
        1965
    ],
    "dreints": [
        1965
    ],
    "drente": [
        1965
    ],
    "drenthe": [
        1965
    ],
    "drèents": [
        1965
    ],
    "drekay": [
        1966
    ],
    "drukai": [
        1966
    ],
    "drukay": [
        1966
    ],
    "dukai": [
        1966
    ],
    "dyokay": [
        1966
    ],
    "darai": [
        1967
    ],
    "dolnoserbšćina": [
        1968
    ],
    "delnoserbski": [
        1968
    ],
    "dolnoserbska reč": [
        1968
    ],
    "dolnoserbska": [
        1968
    ],
    "dolnoserbski": [
        1968
    ],
    "dutch sign language": [
        1969
    ],
    "daasanach": [
        1970
    ],
    "daasanech": [
        1970
    ],
    "dasenech": [
        1970
    ],
    "dathanaik": [
        1970
    ],
    "dhaasanac": [
        1970
    ],
    "disa": [
        1971,
        9128
    ],
    "danish sign language": [
        1972
    ],
    "dts": [
        1972
    ],
    "dansk tegnsprog": [
        1972
    ],
    "dusner": [
        1973
    ],
    "dusnir": [
        1973
    ],
    "desiya": [
        1974,
        5959
    ],
    "desia": [
        1974
    ],
    "desiya oriya": [
        1974
    ],
    "daosahaq": [
        1975,
        1976
    ],
    "daoussahaq": [
        1975,
        1976
    ],
    "daoussak": [
        1975,
        1976
    ],
    "dausahaq": [
        1975,
        1976
    ],
    "dawsahaq": [
        1975,
        1976
    ],
    "daur": [
        1977,
        1978,
        1979,
        1980
    ],
    "daguor": [
        1977,
        1978,
        1979,
        1980
    ],
    "dagur": [
        1977,
        1978,
        1979,
        1980
    ],
    "dawar": [
        1977,
        1978,
        1979,
        1980
    ],
    "dawo’er": [
        1977,
        1978,
        1979,
        1980
    ],
    "ditidaht": [
        1982
    ],
    "diidiitidq": [
        1982
    ],
    "diitiid’aatx": [
        1982
    ],
    "dogon, ana tinga": [
        1984
    ],
    "dogon, tene kan": [
        1985
    ],
    "dogon, tomo kan": [
        1986
    ],
    "daatsʼíin": [
        1987
    ],
    "daatsʼíin": [
        1987
    ],
    "dogon, tommo so": [
        1988
    ],
    "dusan": [
        1989
    ],
    "dusum": [
        1989
    ],
    "dusur": [
        1989
    ],
    "dusun lotud": [
        1990
    ],
    "dogon, toro so": [
        1991
    ],
    "dogon, toro tegu": [
        1992
    ],
    "dogon, tebul ure": [
        1993
    ],
    "dotyali": [
        1994
    ],
    "dotali": [
        1994
    ],
    "doteli": [
        1994
    ],
    "duala": [
        1995,
        2027
    ],
    "duálá": [
        1995
    ],
    "diwala": [
        1995
    ],
    "douala": [
        1995
    ],
    "dualla": [
        1995
    ],
    "dwala": [
        1995
    ],
    "dwela": [
        1995
    ],
    "dubli": [
        1996
    ],
    "dubala": [
        1996
    ],
    "dubla": [
        1996
    ],
    "duna": [
        1997
    ],
    "dumaget": [
        1998
    ],
    "dumagat-bulos": [
        1998
    ],
    "dumaget-bulus": [
        1998
    ],
    "drubea": [
        1999
    ],
    "diubea": [
        1999
    ],
    "dubea": [
        1999
    ],
    "dumbea": [
        1999
    ],
    "duruma": [
        2000
    ],
    "dungra bhil": [
        2001,
        2002
    ],
    "dungra": [
        2001,
        2002
    ],
    "dungri bhil": [
        2001,
        2002
    ],
    "dungri": [
        2001,
        2002,
        2761,
        2762
    ],
    "dumun": [
        2003
    ],
    "duduela": [
        2004
    ],
    "dusun deyah": [
        2007
    ],
    "deyah": [
        2007
    ],
    "deah": [
        2007
    ],
    "dejah": [
        2007
    ],
    "dupaninan": [
        2008
    ],
    "dupaninan agta": [
        2008
    ],
    "dupaningan agta": [
        2008
    ],
    "dupaningan": [
        2008
    ],
    "duano": [
        2009
    ],
    "desin dolak": [
        2009
    ],
    "desin": [
        2009
    ],
    "dolak": [
        2009
    ],
    "desin duano": [
        2009
    ],
    "duano’": [
        2009
    ],
    "dusun malang": [
        2010
    ],
    "dourou": [
        2011
    ],
    "durru": [
        2011
    ],
    "duru": [
        2011
    ],
    "dìì": [
        2011
    ],
    "dumi": [
        2012
    ],
    "dumi bo’o": [
        2012
    ],
    "dumi bro": [
        2012
    ],
    "dumī rāī": [
        2012
    ],
    "dumī": [
        2012
    ],
    "drung": [
        2013
    ],
    "derung": [
        2013
    ],
    "dulong": [
        2013
    ],
    "durung": [
        2013
    ],
    "duvle": [
        2014
    ],
    "duvde": [
        2014
    ],
    "duve": [
        2014
    ],
    "duvele": [
        2014
    ],
    "duvre": [
        2014
    ],
    "dusun witu": [
        2015
    ],
    "duungooma": [
        2016
    ],
    "duungo": [
        2016
    ],
    "dicamay": [
        2017
    ],
    "dicamay agta": [
        2017
    ],
    "dicamay dumagat": [
        2017
    ],
    "duli-gey": [
        2018
    ],
    "dui": [
        2018,
        3550,
        3551,
        3552
    ],
    "duli": [
        2018
    ],
    "duli-gewe": [
        2018
    ],
    "dhivehi": [
        2019,
        2020
    ],
    "dhivehi bas": [
        2019,
        2020
    ],
    "divehi": [
        2019,
        2020
    ],
    "divehli": [
        2019,
        2020
    ],
    "duau": [
        2021,
        6796
    ],
    "diri": [
        2022,
        2843
    ],
    "diriya": [
        2022
    ],
    "dirya": [
        2022
    ],
    "diryanci": [
        2022
    ],
    "diryawa": [
        2022
    ],
    "dawik": [
        2023
    ],
    "dawik kui": [
        2023
    ],
    "dawro": [
        2024,
        2025
    ],
    "dawrogna": [
        2024
    ],
    "dutton world speedwords": [
        2026
    ],
    "dutton": [
        2026
    ],
    "dhuwal": [
        2027
    ],
    "dual": [
        2027
    ],
    "dawawa": [
        2028
    ],
    "dawana": [
        2028
    ],
    "dhuwaya": [
        2029
    ],
    "dewas rai": [
        2030
    ],
    "dewas": [
        2030
    ],
    "danuwar rai": [
        2030
    ],
    "dyan": [
        2031
    ],
    "dya": [
        2031
    ],
    "dyane": [
        2031
    ],
    "dyanu": [
        2031
    ],
    "dyaberdyaber": [
        2032
    ],
    "dyugun": [
        2033
    ],
    "djugun": [
        2033
    ],
    "djimini": [
        2035
    ],
    "djimini senoufo": [
        2035
    ],
    "dyimini": [
        2035
    ],
    "dogon, yanda dom": [
        2036
    ],
    "dyangadi": [
        2037
    ],
    "dainggati": [
        2037
    ],
    "dangadi": [
        2037
    ],
    "dangati": [
        2037
    ],
    "danggadi": [
        2037
    ],
    "danggetti": [
        2037
    ],
    "dhanggati": [
        2037
    ],
    "dhanggatti": [
        2037
    ],
    "djan-gadi": [
        2037
    ],
    "diola": [
        2038,
        2039
    ],
    "diola-fogny": [
        2038,
        2039
    ],
    "dyola": [
        2038,
        2039
    ],
    "dioula véhiculaire": [
        2040,
        2041,
        2042
    ],
    "diula": [
        2040,
        2041,
        2042
    ],
    "djula": [
        2040,
        2041,
        2042
    ],
    "dyula": [
        2040,
        2041,
        2042
    ],
    "djabugay": [
        2043
    ],
    "djabugai": [
        2043
    ],
    "dyaabugay": [
        2043
    ],
    "dyabugay": [
        2043
    ],
    "dzongkha": [
        2044
    ],
    "dukpa": [
        2044
    ],
    "drokpa": [
        2044
    ],
    "drukha": [
        2044
    ],
    "drukke": [
        2044
    ],
    "drukpa": [
        2044
    ],
    "dugusa": [
        2045
    ],
    "duguza": [
        2045
    ],
    "djiwarli": [
        2046
    ],
    "djiwali": [
        2046
    ],
    "djwarli": [
        2046
    ],
    "dazaga": [
        2047
    ],
    "dasa": [
        2047,
        3137
    ],
    "daza": [
        2047
    ],
    "dazza": [
        2047
    ],
    "dzalakha": [
        2048
    ],
    "dzala": [
        2048
    ],
    "dzalamat": [
        2048
    ],
    "dzando": [
        2049
    ],
    "diés": [
        2067
    ],
    "dutse": [
        2069,
        3300
    ],
    "dehes": [
        2099
    ],
    "darien": [
        2109
    ],
    "darien emberá": [
        2109
    ],
    "darién": [
        2109
    ],
    "dg": [
        2143
    ],
    "diego garcia": [
        2143
    ],
    "diego": [
        2143
    ],
    "dm": [
        2145
    ],
    "dominica": [
        2145
    ],
    "danba": [
        2251
    ],
    "daofu": [
        2251
    ],
    "daofuhua": [
        2251
    ],
    "dawu": [
        2251,
        7314
    ],
    "doxu": [
        2253
    ],
    "duoxu": [
        2253
    ],
    "declarado": [
        2300,
        2301
    ],
    "diklaradu": [
        2300,
        2301
    ],
    "d’ambu": [
        2332
    ],
    "dambu": [
        2332
    ],
    "d’ambô": [
        2332
    ],
    "d’oreille": [
        2396
    ],
    "doreille": [
        2396
    ],
    "doa": [
        2397,
        7304
    ],
    "dahomeen": [
        2413
    ],
    "djedji": [
        2413
    ],
    "domona": [
        2479,
        2480
    ],
    "dzemay": [
        2479,
        2480
    ],
    "djallon": [
        2483,
        2484,
        2485
    ],
    "dyalon": [
        2483,
        2484,
        2485
    ],
    "dala": [
        2500
    ],
    "darbé-dormon": [
        2509
    ],
    "didayi": [
        2528
    ],
    "didei": [
        2528
    ],
    "dire": [
        2528
    ],
    "defi": [
        2546
    ],
    "defi gbe": [
        2546
    ],
    "défi": [
        2546
    ],
    "dhapil": [
        2561
    ],
    "dhipil": [
        2561
    ],
    "dippil": [
        2561
    ],
    "dipple": [
        2561
    ],
    "doon-dooburra": [
        2561
    ],
    "doondoora": [
        2561
    ],
    "dowarburra": [
        2561
    ],
    "dundubara": [
        2561
    ],
    "dunduura": [
        2561
    ],
    "dari, zoroastrian": [
        2564
    ],
    "dhunkuria": [
        2574
    ],
    "domba": [
        2574
    ],
    "dombiali": [
        2574
    ],
    "dirasha": [
        2586,
        2587
    ],
    "draping": [
        2650
    ],
    "dê": [
        2651,
        6457
    ],
    "dogba": [
        2652
    ],
    "duoluo": [
        2655
    ],
    "dhauhurtwurru": [
        2661
    ],
    "dhauwurd wurrung": [
        2661
    ],
    "dhauwurd": [
        2661
    ],
    "d’iro": [
        2679
    ],
    "dye": [
        2709
    ],
    "dxana": [
        2713
    ],
    "daribalang": [
        2718
    ],
    "dalo": [
        2723
    ],
    "dipa": [
        2723
    ],
    "dadjriwalé": [
        2726
    ],
    "dau": [
        2742,
        8648,
        5016
    ],
    "dhungri garasia": [
        2761,
        2762
    ],
    "dhungri": [
        2761,
        2762
    ],
    "dungari garasia": [
        2761,
        2762
    ],
    "dungari": [
        2761,
        2762
    ],
    "dungri grasia": [
        2761,
        2762
    ],
    "dgs": [
        2788,
        6811
    ],
    "deutsche gebärdensprache": [
        2788
    ],
    "deutsche": [
        2788
    ],
    "dida, yocoboué": [
        2806
    ],
    "dída": [
        2806
    ],
    "dida de yocoboué": [
        2806
    ],
    "deguba": [
        2811,
        2812
    ],
    "duwet": [
        2829
    ],
    "digüt": [
        2835
    ],
    "daduwa": [
        2837
    ],
    "domdom": [
        2839
    ],
    "dir kohistani": [
        2843
    ],
    "dir": [
        2843
    ],
    "dirwali": [
        2843
    ],
    "dinju zhuh k'yuu": [
        2848
    ],
    "dinju": [
        2848
    ],
    "dinju zhuh k’yuu": [
        2848
    ],
    "dcui": [
        2849
    ],
    "dawson": [
        2882
    ],
    "doan": [
        2966
    ],
    "duan": [
        2966
    ],
    "da hua bei miao": [
        2973,
        2974,
        2975
    ],
    "da hua miao": [
        2973,
        2974,
        2975
    ],
    "da-hua miao": [
        2973,
        2974,
        2975
    ],
    "da-hua": [
        2973,
        2974,
        2975
    ],
    "diandongbei miao": [
        2973,
        2974,
        2975
    ],
    "diandongbei": [
        2973,
        2974,
        2975
    ],
    "don": [
        2977,
        3710,
        4313
    ],
    "deo": [
        2981
    ],
    "dlai": [
        2986
    ],
    "dô": [
        2994
    ],
    "dihungu": [
        3002
    ],
    "da holmaci": [
        3024
    ],
    "davach": [
        3047,
        3048
    ],
    "davak": [
        3047,
        3048
    ],
    "dá vách": [
        3047,
        3048
    ],
    "dá": [
        3047,
        3048
    ],
    "dionisio": [
        3097,
        9169
    ],
    "daman-diu portuguese": [
        3135
    ],
    "daman-diu": [
        3135
    ],
    "diblaeg": [
        3139
    ],
    "dimisi": [
        3139
    ],
    "dimsisi": [
        3139
    ],
    "deen": [
        3171
    ],
    "deenma": [
        3171
    ],
    "denma": [
        3171
    ],
    "dhiyin": [
        3171
    ],
    "dhiyinma": [
        3171
    ],
    "deg xinag": [
        3214
    ],
    "deg xit’an": [
        3214
    ],
    "degexit'an": [
        3214
    ],
    "degexit’an": [
        3214
    ],
    "division": [
        3259,
        7293
    ],
    "dsekiri": [
        3274
    ],
    "dao do": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "dao thanh phan": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "dìu": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "diakanka": [
        3308
    ],
    "diakhanke": [
        3308
    ],
    "diakkanke": [
        3308
    ],
    "dyakanke": [
        3308
    ],
    "djakun": [
        3313
    ],
    "djandai": [
        3316
    ],
    "djendewal": [
        3316
    ],
    "dsandai": [
        3316
    ],
    "daerah": [
        3322,
        9077,
        9078
    ],
    "djambi": [
        3322
    ],
    "dhanguny’": [
        3323
    ],
    "diahoue": [
        3324
    ],
    "dombano": [
        3327
    ],
    "djerbi": [
        3330
    ],
    "djeoromitxí": [
        3333
    ],
    "diyi": [
        3334
    ],
    "diyu": [
        3334
    ],
    "dzad": [
        3339
    ],
    "dzhuhuric": [
        3341,
        3342,
        3343
    ],
    "die": [
        3346,
        3347,
        6082
    ],
    "dza": [
        3351
    ],
    "dzâ": [
        3351
    ],
    "djongor bourmataguil": [
        3354
    ],
    "djongor": [
        3354
    ],
    "dougne": [
        3354
    ],
    "djingila": [
        3367
    ],
    "djingili": [
        3367
    ],
    "djingulu": [
        3367
    ],
    "dermuha": [
        3381
    ],
    "daloka": [
        3387
    ],
    "darra": [
        3387
    ],
    "dimadima": [
        3389
    ],
    "dzanggali": [
        3406
    ],
    "dzhidi": [
        3417
    ],
    "djudi": [
        3417
    ],
    "djarai": [
        3419,
        3420
    ],
    "drai": [
        3419,
        3420
    ],
    "doora": [
        3431,
        5613
    ],
    "djawa": [
        3444,
        3445
    ],
    "dgyarung": [
        3449
    ],
    "dashanhua": [
        3461
    ],
    "dam fer": [
        3466
    ],
    "djapá": [
        3831,
        3474
    ],
    "dla": [
        3500
    ],
    "dera": [
        3821,
        3500
    ],
    "dera (indonesia)": [
        3500
    ],
    "dra": [
        3500
    ],
    "duhwa": [
        3505
    ],
    "dialectes de l’extreme sud": [
        3542
    ],
    "dialectes": [
        3542
    ],
    "duauru": [
        3542
    ],
    "douon": [
        3550,
        3551,
        3552
    ],
    "dikele": [
        3559
    ],
    "deiga": [
        3560
    ],
    "duisalongmei": [
        3615
    ],
    "dimodongo": [
        3632
    ],
    "dori": [
        3640
    ],
    "dai le": [
        3645,
        3646
    ],
    "duon": [
        3645,
        3646
    ],
    "dhed gujari": [
        3655
    ],
    "dhed": [
        3655
    ],
    "dabu": [
        3687
    ],
    "dersimki": [
        3688
    ],
    "dersımki": [
        3688
    ],
    "dimilki": [
        3688
    ],
    "dımılki": [
        3688
    ],
    "damai": [
        3702,
        3703,
        3704,
        8559
    ],
    "damailao": [
        3702,
        3703,
        3704
    ],
    "damaile": [
        3702,
        3703,
        3704
    ],
    "dang": [
        3978,
        4248,
        6062,
        6063,
        6777,
        7476,
        3710,
        7870
    ],
    "danezāgé’": [
        3762
    ],
    "dena": [
        3762
    ],
    "dumu": [
        3780
    ],
    "dong, southern": [
        3794,
        3795
    ],
    "dâŋ": [
        3799
    ],
    "dera (nigeria)": [
        3821
    ],
    "dayak kaninjal": [
        3830
    ],
    "damea": [
        3844
    ],
    "democratic people's republic of korea": [
        3849
    ],
    "denaakk’e": [
        3871
    ],
    "doromu-koki": [
        3900
    ],
    "dorom": [
        3900
    ],
    "doromu": [
        3900
    ],
    "durop": [
        3940
    ],
    "dyurop": [
        3940
    ],
    "dzek": [
        3948
    ],
    "dzhek": [
        3948
    ],
    "dzheki": [
        3948
    ],
    "digoel": [
        3999
    ],
    "digul": [
        3999
    ],
    "district": [
        4005,
        4183
    ],
    "dobe kung": [
        4006
    ],
    "dobe": [
        4006
    ],
    "dzu’oasi": [
        4006
    ],
    "diila": [
        4029
    ],
    "dena’ina": [
        4035,
        7438
    ],
    "dinakʼi": [
        4035
    ],
    "dalam": [
        4046,
        4870
    ],
    "deleh": [
        4056
    ],
    "dobel": [
        4059
    ],
    "doibel": [
        4059
    ],
    "daneh": [
        4061,
        4062
    ],
    "dâw": [
        4073
    ],
    "dow": [
        4073
    ],
    "démé": [
        4079
    ],
    "demi": [
        4079
    ],
    "deme": [
        4079
    ],
    "dana": [
        4093
    ],
    "dialects": [
        4106
    ],
    "daeng": [
        7870,
        4152,
        4153,
        4154
    ],
    "dharua": [
        4156,
        4157,
        4158
    ],
    "da’a": [
        4167,
        8539
    ],
    "da'a kaili": [
        4167
    ],
    "daa": [
        4167
    ],
    "duat": [
        4169
    ],
    "dio": [
        4175
    ],
    "dzubukuá": [
        4181,
        7463
    ],
    "dikango": [
        4183
    ],
    "djidió": [
        4189
    ],
    "djudeo-espagnol": [
        4189,
        4190,
        4191
    ],
    "djudezmo": [
        4189,
        4190,
        4191
    ],
    "djudyó": [
        4189,
        4190,
        4191
    ],
    "dschudeo-espanjol": [
        4189,
        4190,
        4191
    ],
    "dzhudeo-espanyol": [
        4189,
        4190,
        4191
    ],
    "dzhudezmo": [
        4189,
        4190,
        4191
    ],
    "dzidió": [
        4189,
        4190,
        4191
    ],
    "dzsudeo-eszpanyol": [
        4189,
        4190,
        4191
    ],
    "dzudezmo": [
        4189,
        4190,
        4191
    ],
    "dżudeo-espańol": [
        4189,
        4190,
        4191
    ],
    "džudeo-espanjol": [
        4189,
        4190,
        4191
    ],
    "dowyan": [
        4213,
        4214
    ],
    "duya": [
        4253
    ],
    "dũya": [
        4253
    ],
    "doku": [
        4309
    ],
    "digenja": [
        4312
    ],
    "dung": [
        4313,
        8923,
        8924,
        8925,
        8926
    ],
    "dzyükki": [
        4317
    ],
    "dli": [
        4326
    ],
    "dzowo": [
        4331
    ],
    "da’ang": [
        4351,
        6065,
        6191
    ],
    "dal-leyburra": [
        4355
    ],
    "dalebura": [
        4355
    ],
    "dalleburra": [
        4355
    ],
    "dhi-pari": [
        4369
    ],
    "dolomite": [
        4377
    ],
    "dayeh": [
        4425
    ],
    "daya": [
        4425
    ],
    "dayah": [
        4425
    ],
    "daye": [
        4425
    ],
    "dayoh": [
        4425
    ],
    "daantanai’": [
        4429
    ],
    "daantanai'": [
        4429
    ],
    "djiri": [
        4455
    ],
    "dayao": [
        4471,
        4472
    ],
    "deni": [
        4491
    ],
    "dholuo": [
        4529
    ],
    "doluo": [
        4529
    ],
    "duhlian twang": [
        4533,
        4534,
        4535
    ],
    "duhlian": [
        4533,
        4534,
        4535
    ],
    "dulien": [
        4533,
        4534,
        4535
    ],
    "dəxʷləšucid": [
        4536
    ],
    "dxʷləšucid": [
        4536
    ],
    "dhe luuo": [
        4554,
        4555
    ],
    "dhe": [
        4554,
        4555,
        7485
    ],
    "dhe luwo": [
        4554
    ],
    "dhe lwo": [
        4554
    ],
    "dheluwo": [
        4554
    ],
    "dhɛ luuhɔ": [
        4554
    ],
    "dhɛ": [
        4554
    ],
    "díaz": [
        4581
    ],
    "dibabawon": [
        4603
    ],
    "debabaon": [
        4603
    ],
    "dibabaon": [
        4603
    ],
    "dibabauon": [
        4603
    ],
    "dibabawon manobo": [
        4603
    ],
    "damana": [
        4614
    ],
    "dəməna": [
        4614
    ],
    "dʉmʉna": [
        4614
    ],
    "dudi": [
        4627
    ],
    "de’cuana": [
        4632
    ],
    "de’kwana": [
        4632
    ],
    "de’kwana carib": [
        4632
    ],
    "dâg tì mà̧mbày": [
        4643
    ],
    "dâg": [
        4643
    ],
    "dabura": [
        4652
    ],
    "djema": [
        4655,
        4656
    ],
    "djemma": [
        4655,
        4656
    ],
    "dizin": [
        4675,
        4676
    ],
    "distrito": [
        4686
    ],
    "djawali": [
        4691
    ],
    "djuwali": [
        4691
    ],
    "diokpang": [
        4713
    ],
    "douvangar": [
        4720
    ],
    "doba": [
        4744
    ],
    "doloman": [
        4772
    ],
    "digaro-mishmi": [
        4785
    ],
    "darang": [
        4785
    ],
    "darang deng": [
        4785
    ],
    "darang dengyu": [
        4785
    ],
    "dengyu": [
        4785
    ],
    "digaro": [
        4785
    ],
    "digaru": [
        4785
    ],
    "diso": [
        4787
    ],
    "da’an davi": [
        4800,
        4812,
        8646
    ],
    "da’an": [
        4800,
        4812,
        8646
    ],
    "davi": [
        4812,
        4817,
        4800,
        8646
    ],
    "da'an davi": [
        4812
    ],
    "daan": [
        4812
    ],
    "dao ao dai": [
        4824
    ],
    "dao lam dinh": [
        4824
    ],
    "dinh": [
        4824
    ],
    "dao quan trang": [
        4824
    ],
    "dao thanh y": [
        4824
    ],
    "dehri": [
        4848
    ],
    "dhatki": [
        4853,
        4854
    ],
    "dhati": [
        4853
    ],
    "doriri": [
        4861
    ],
    "dumbule": [
        4876
    ],
    "dirak": [
        4905
    ],
    "dhora": [
        4911
    ],
    "dora": [
        4911
    ],
    "dyuremáwa": [
        4921
    ],
    "dzúreme": [
        4921
    ],
    "dzúremene": [
        4921
    ],
    "dionkor": [
        4924
    ],
    "djonkor": [
        4924,
        4983
    ],
    "dyongor": [
        4924,
        4983
    ],
    "djonggunu": [
        4959
    ],
    "dhimorong": [
        4973
    ],
    "diongor guera": [
        4983
    ],
    "diongor": [
        4983
    ],
    "djonkor guera": [
        4983
    ],
    "dyongor guera": [
        4983
    ],
    "dadibi": [
        5002
    ],
    "daribi": [
        5002
    ],
    "djanggu": [
        5044
    ],
    "dak": [
        5054,
        5055,
        7389
    ],
    "dineor": [
        5064
    ],
    "demenggong-waibron-bano": [
        5078
    ],
    "dulangan manobo": [
        5101
    ],
    "dulangan": [
        5101
    ],
    "dawi": [
        5124
    ],
    "du adzu": [
        5128
    ],
    "daganonga": [
        5138
    ],
    "daganyonga": [
        5138
    ],
    "duri": [
        5164
    ],
    "dhundari": [
        5190
    ],
    "dhundari-marwari": [
        5190
    ],
    "dhundhari": [
        5190
    ],
    "daw": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "der": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "dleu": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "dleub": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "dawb": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "dend": [
        5214
    ],
    "dorro": [
        5227
    ],
    "domingo": [
        8987,
        5229,
        7576
    ],
    "dukwayasi": [
        5251
    ],
    "diꞌ": [
        5271
    ],
    "di’": [
        5271
    ],
    "dɛg": [
        5278
    ],
    "degha": [
        5278
    ],
    "dorerin naoero": [
        5282
    ],
    "dorerin": [
        5282
    ],
    "damaqua": [
        5300
    ],
    "damara": [
        5300
    ],
    "dugun": [
        5378
    ],
    "dauwa": [
        5381
    ],
    "dawa": [
        5381
    ],
    "dhao": [
        5415
    ],
    "dzama": [
        5418
    ],
    "dingando": [
        5424
    ],
    "dalabon": [
        5430
    ],
    "dangbon": [
        5430
    ],
    "dengurume": [
        5435
    ],
    "djanti": [
        5443
    ],
    "dayak ngaju": [
        5476
    ],
    "d": [
        5480
    ],
    "dru": [
        5491
    ],
    "druna": [
        5491
    ],
    "djem": [
        5508
    ],
    "dzem": [
        5508
    ],
    "dafla": [
        5509,
        5510
    ],
    "daphla": [
        5509,
        5510
    ],
    "duke": [
        5515,
        6462
    ],
    "doumbou": [
        5564
    ],
    "dumbu": [
        5564
    ],
    "duidui": [
        5594
    ],
    "dwang": [
        5612
    ],
    "dwan": [
        5612
    ],
    "dgernesiais": [
        5667
    ],
    "desert": [
        5714
    ],
    "delo": [
        5719
    ],
    "driafleisuma": [
        5749
    ],
    "diné": [
        5752
    ],
    "diné bizaad": [
        5752
    ],
    "dogon, nanga dama": [
        5821
    ],
    "dyo’xaiya-o-lvo’tsa": [
        5835
    ],
    "dhegiha": [
        5904
    ],
    "dohema": [
        5946
    ],
    "danum": [
        5982
    ],
    "dohoi": [
        5982
    ],
    "dhitoro": [
        5990
    ],
    "daawaamwin": [
        5994
    ],
    "dapera": [
        6000
    ],
    "dalska": [
        6004
    ],
    "daiomuni": [
        6010
    ],
    "djimu": [
        6011
    ],
    "dzimou": [
        6011
    ],
    "dioi": [
        6062,
        6063,
        8882
    ],
    "di-ang": [
        6065,
        6066
    ],
    "dlang": [
        6065
    ],
    "duruwa": [
        6072,
        6073
    ],
    "dhruva": [
        6072,
        6073
    ],
    "dhurwa": [
        6072,
        6073
    ],
    "durva": [
        6072,
        6073
    ],
    "deitsch": [
        6082
    ],
    "die mudderschprooch": [
        6082
    ],
    "deitsh": [
        6082
    ],
    "dagoi": [
        6091
    ],
    "dagui": [
        6091
    ],
    "dangarikwar": [
        6126
    ],
    "dearwa": [
        6145
    ],
    "deruwa": [
        6145
    ],
    "deá’ru’wa": [
        6145
    ],
    "de’aruwã thiwene": [
        6145
    ],
    "de’aruwã": [
        6145
    ],
    "dearuwa": [
        6145
    ],
    "dzaze": [
        6155
    ],
    "dejá": [
        6155
    ],
    "daakie": [
        6351
    ],
    "delta pwo karen": [
        6380
    ],
    "daniel carrion": [
        6409
    ],
    "daniel": [
        6409
    ],
    "dos de mayo quechua": [
        6422
    ],
    "dungmali": [
        6454
    ],
    "dungmali puk": [
        6454
    ],
    "dungmali pûk": [
        6454
    ],
    "dungmali-bantawa": [
        6454
    ],
    "duke of york": [
        6462
    ],
    "daru-zerwang": [
        6478
    ],
    "dangraq": [
        6479
    ],
    "dakhum": [
        6482
    ],
    "daraga": [
        6488
    ],
    "drum": [
        6523
    ],
    "dafing": [
        6536
    ],
    "domari": [
        6560
    ],
    "daco-romanian": [
        6575,
        6577,
        6578
    ],
    "daco-rumanian": [
        6575,
        6576,
        6577,
        6578,
        6579
    ],
    "danubian": [
        6588,
        6590
    ],
    "dela-oenale": [
        6595
    ],
    "dela": [
        6595
    ],
    "delha": [
        6595
    ],
    "deva bhasha": [
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657
    ],
    "deva": [
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657
    ],
    "deva vani": [
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657
    ],
    "dlo kêt": [
        6685
    ],
    "dlo": [
        6685
    ],
    "dongxiang": [
        6720,
        6721
    ],
    "dikku kaji": [
        6726,
        6727
    ],
    "dikku": [
        6726,
        6727
    ],
    "doda’": [
        6767
    ],
    "davvisámegiella": [
        6770,
        6772,
        6773
    ],
    "davvin": [
        6770,
        6771
    ],
    "dadang": [
        6777
    ],
    "duranmin": [
        6788
    ],
    "duau pwata": [
        6796
    ],
    "dsgs": [
        6811
    ],
    "deutschschweizer gebärdensprache": [
        6811
    ],
    "deutschschweizer": [
        6811
    ],
    "deutschschweizerische gebärdensprache": [
        6811
    ],
    "deutschschweizerische": [
        6811
    ],
    "damilo": [
        6823
    ],
    "dap": [
        6823
    ],
    "drokpakay": [
        6823
    ],
    "dhocolo": [
        6841,
        6842
    ],
    "dehong": [
        6845,
        6846,
        6847,
        6848,
        7386,
        7387
    ],
    "dandzongka": [
        6879
    ],
    "danjongka": [
        6879
    ],
    "danyouka": [
        6879
    ],
    "denjong": [
        6879
    ],
    "denjong-skad": [
        6879
    ],
    "denjongke": [
        6879
    ],
    "denjongkha": [
        6879
    ],
    "denjongkä": [
        6879
    ],
    "denjongpa": [
        6879
    ],
    "denjonka": [
        6879
    ],
    "denjonke": [
        6879
    ],
    "denzong ke": [
        6879
    ],
    "denzong": [
        6879
    ],
    "denzongke": [
        6879
    ],
    "denzongpe ke": [
        6879
    ],
    "denzongpe": [
        6879
    ],
    "denzongpeke": [
        6879
    ],
    "dranjoke": [
        6879
    ],
    "dranjongke": [
        6879
    ],
    "drendzongké": [
        6879
    ],
    "dammai": [
        6895
    ],
    "dhammai": [
        6895
    ],
    "dat": [
        6905
    ],
    "dol": [
        6916
    ],
    "dinangat": [
        6922
    ],
    "della": [
        6944
    ],
    "dinanget": [
        6965
    ],
    "dilaut": [
        6972
    ],
    "defayan": [
        6979
    ],
    "dambro": [
        7043
    ],
    "d-saqátri": [
        7084,
        7085
    ],
    "dgiéh": [
        7163
    ],
    "de gammon": [
        7164
    ],
    "damulian": [
        7296,
        7297
    ],
    "darha": [
        7304
    ],
    "dharawal": [
        7335
    ],
    "dharawaal": [
        7335
    ],
    "djaul": [
        7337
    ],
    "diebroud": [
        7344
    ],
    "dabra": [
        7344
    ],
    "ditammari": [
        7354
    ],
    "ditamari": [
        7354
    ],
    "du-ûgü": [
        7355
    ],
    "duuxugu": [
        7355
    ],
    "duüxügu": [
        7355
    ],
    "datooga": [
        7357
    ],
    "datog": [
        7357
    ],
    "datoga": [
        7357
    ],
    "dai kong": [
        7386,
        7387
    ],
    "dai na": [
        7386,
        7387
    ],
    "dai nuea": [
        7386,
        7387
    ],
    "daide": [
        7386,
        7387
    ],
    "dehong dai": [
        7386,
        7387
    ],
    "dogon, tiranige diga": [
        7388
    ],
    "diga": [
        7388
    ],
    "duleri": [
        7388
    ],
    "duleri dom": [
        7388
    ],
    "dishili": [
        7396
    ],
    "didra": [
        7401
    ],
    "didrah": [
        7401
    ],
    "doutai": [
        7402
    ],
    "dili tetum": [
        7403
    ],
    "dujos": [
        7420
    ],
    "demba": [
        7439
    ],
    "dzboku’a": [
        7463
    ],
    "dene k’e": [
        7465
    ],
    "da:galag": [
        7467
    ],
    "dagalang": [
        7467
    ],
    "dolakha": [
        7472
    ],
    "dangaura": [
        7476
    ],
    "dangaha": [
        7476
    ],
    "dangali": [
        7476
    ],
    "dangauli": [
        7476
    ],
    "dangaura tharu": [
        7476
    ],
    "dangora": [
        7476
    ],
    "dangura": [
        7476
    ],
    "dhe thuri": [
        7485
    ],
    "djungunjdji": [
        7523
    ],
    "djuroro": [
        7530
    ],
    "djurruru": [
        7530
    ],
    "djururo": [
        7530
    ],
    "dyururu": [
        7530
    ],
    "djabwurrung": [
        7531
    ],
    "djab wurrung": [
        7531
    ],
    "djab": [
        7531
    ],
    "djab wurung": [
        7531
    ],
    "djabwuru": [
        7531
    ],
    "djabwurung": [
        7531
    ],
    "dyabwurung": [
        7531
    ],
    "dyapwurong": [
        7531
    ],
    "dije": [
        7589
    ],
    "darat": [
        7600,
        7856
    ],
    "dayak taman": [
        7602
    ],
    "domurik": [
        7606
    ],
    "debbarma": [
        7714,
        7715
    ],
    "daiya-ataiyal": [
        7722
    ],
    "dirang": [
        7738
    ],
    "dausame": [
        7750
    ],
    "dausuami mubami": [
        7750
    ],
    "dausuami": [
        7750
    ],
    "dochkafuara": [
        7787
    ],
    "doka-poara": [
        7787
    ],
    "dokapuara": [
        7787
    ],
    "doxká-poárá": [
        7787
    ],
    "dasea ye": [
        7796
    ],
    "dasea": [
        7796
    ],
    "dachsea": [
        7796
    ],
    "dahseyé": [
        7796
    ],
    "daxsea": [
        7796
    ],
    "dawai": [
        7810
    ],
    "dawe": [
        7810
    ],
    "dawei": [
        7810
    ],
    "dón": [
        7825,
        7826
    ],
    "dwags": [
        7828
    ],
    "dusun tatana": [
        7858
    ],
    "dhayban": [
        7869
    ],
    "diba": [
        7875
    ],
    "damal": [
        7927
    ],
    "divers bay": [
        8006
    ],
    "divers": [
        8006
    ],
    "duka": [
        8020,
        8024
    ],
    "dukawa": [
        8020,
        8024
    ],
    "doko-uyanga": [
        8037
    ],
    "dosanga": [
        8037
    ],
    "dhanagari": [
        8049
    ],
    "dumo": [
        8054
    ],
    "duso": [
        8054
    ],
    "darmdo minyag": [
        8276
    ],
    "darmdo": [
        8276
    ],
    "daktjerat": [
        8304
    ],
    "djeradj": [
        8304
    ],
    "djerag": [
        8304
    ],
    "djeraidy": [
        8304
    ],
    "dyeraidy": [
        8304
    ],
    "degano": [
        8352
    ],
    "dumpu": [
        8353
    ],
    "dorig": [
        8377
    ],
    "dardanup": [
        8381
    ],
    "doonin": [
        8381
    ],
    "dordenup": [
        8381
    ],
    "dornderupwongy": [
        8381
    ],
    "dunanwongi": [
        8381
    ],
    "drualat-ngolonung": [
        8417
    ],
    "drualatngolonung": [
        8417
    ],
    "dulingbara": [
        8426
    ],
    "darkinyung": [
        8443
    ],
    "darginjang": [
        8443
    ],
    "darginyung": [
        8443
    ],
    "darkinjang": [
        8443
    ],
    "darkinoong": [
        8443
    ],
    "darkinung": [
        8443
    ],
    "darknung": [
        8443
    ],
    "dacian": [
        8444,
        8445
    ],
    "dharuk": [
        8446
    ],
    "darrook": [
        8446
    ],
    "darug": [
        8446
    ],
    "dharrook": [
        8446
    ],
    "dharruk": [
        8446
    ],
    "dharug": [
        8446
    ],
    "dhar’rook": [
        8446
    ],
    "djagaraga": [
        8463
    ],
    "dharumbal": [
        8468
    ],
    "darambal": [
        8468
    ],
    "darawal": [
        8468
    ],
    "darumbal": [
        8468
    ],
    "dagaare-dioula": [
        8509
    ],
    "diuxi-tilantongo": [
        8648
    ],
    "diuxi-tilantongo mixtec": [
        8648
    ],
    "dañudavi": [
        8653
    ],
    "dhawa": [
        8665
    ],
    "da’wan’du": [
        8666
    ],
    "dacournditch": [
        8692
    ],
    "derbal": [
        8695
    ],
    "dialonke": [
        8729,
        8730
    ],
    "dialonké": [
        8729,
        8730
    ],
    "djallonke": [
        8729,
        8730
    ],
    "dyalonke": [
        8729,
        8730
    ],
    "djao": [
        8733,
        8734
    ],
    "dschang": [
        8747
    ],
    "dewansala": [
        8750
    ],
    "daizhanpho": [
        8792
    ],
    "digaopho": [
        8792
    ],
    "deba": [
        8799
    ],
    "dongshanba": [
        8801
    ],
    "dongshanba lalo": [
        8801
    ],
    "dhidhanu": [
        8802
    ],
    "dnye": [
        8829
    ],
    "dubuporo": [
        8863
    ],
    "duoi": [
        8882
    ],
    "du’o’i": [
        8882
    ],
    "da ia": [
        8898
    ],
    "daban yao": [
        8898
    ],
    "daban": [
        8898
    ],
    "dian dongbei yi": [
        8949,
        8950
    ],
    "dongbei": [
        8949,
        8950
    ],
    "ditsa": [
        8970
    ],
    "didza-xhon": [
        8972
    ],
    "dzalamo": [
        8979
    ],
    "dizte chaan zha ozolotepec": [
        8983
    ],
    "dizte": [
        8983
    ],
    "diste": [
        8983,
        9165
    ],
    "diidxazá": [
        8984
    ],
    "didzaʼ xidzaʼ": [
        8986
    ],
    "didzaʼ": [
        8986
    ],
    "didza’ xidza’": [
        8986
    ],
    "didza’": [
        8986
    ],
    "dihidx bilyáhab": [
        8987
    ],
    "dihidx": [
        8987
    ],
    "dižə'əxon": [
        8990
    ],
    "diosənꞌ": [
        8990
    ],
    "diozənꞌ": [
        8990
    ],
    "dižə’əxon": [
        8990
    ],
    "didxsaj": [
        8991
    ],
    "draba": [
        9043
    ],
    "dai zhuang": [
        9044,
        9045
    ],
    "dejing": [
        9181,
        9044,
        9045
    ],
    "daez": [
        9047,
        9048
    ],
    "dea": [
        9053
    ],
    "djime": [
        9055
    ],
    "djiwe": [
        9055
    ],
    "dzinda": [
        9056
    ],
    "dzindza": [
        9056
    ],
    "diidx zah": [
        9125
    ],
    "diidx": [
        9125
    ],
    "didz-rieꞌ": [
        9126
    ],
    "dialu": [
        9131
    ],
    "dìidz-zè": [
        9132
    ],
    "diidz rii": [
        9132
    ],
    "diidz": [
        9132,
        9161
    ],
    "dizhze": [
        9134
    ],
    "diža'xon": [
        9136
    ],
    "dizha’ xhon": [
        9136
    ],
    "dizha’": [
        9136
    ],
    "diža’xon": [
        9136
    ],
    "dìʼll wlhàll yàlhálhg": [
        9140
    ],
    "dìʼll": [
        9140
    ],
    "dxiꞌzah": [
        9141
    ],
    "diidz zë": [
        9161
    ],
    "didxa shiza'": [
        9171
    ],
    "didxa": [
        9171
    ],
    "didxa shiza’": [
        9171
    ],
    "didza shon": [
        9171
    ],
    "didza": [
        9171
    ],
    "dejing zhuang": [
        9181
    ],
    "dianbao": [
        9181
    ],
    "dimili": [
        9186,
        9187
    ],
    "dimilî": [
        9186,
        9187
    ],
    "dimli (macrolanguage)": [
        9186,
        9187
    ],
    "dimli": [
        9186,
        9187
    ],
    "dimlî": [
        9186,
        9187
    ]
};
